"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _func = require("../utils/func");

var _shallowEqual = _interopRequireDefault(require("../utils/shallowEqual"));

var _types = require("./types");

var _List = _interopRequireDefault(require("./List"));

var _Form = _interopRequireDefault(require("./Form"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var types = {
  form: _Form.default,
  list: _List.default
};

var _default = (0, _func.curry)(function (options, Origin) {
  var _class, _temp;

  var _ref = options || {},
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'list' : _ref$type,
      _ref$key = _ref.key,
      key = _ref$key === void 0 ? 'value' : _ref$key,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 0 : _ref$limit,
      _ref$bindProps = _ref.bindProps,
      bindProps = _ref$bindProps === void 0 ? [] : _ref$bindProps,
      ignoreUndefined = _ref.ignoreUndefined,
      _ref$pure = _ref.pure,
      pure = _ref$pure === void 0 ? true : _ref$pure;

  var Datum = types[type];
  var Component = pure ? _react.default.PureComponent : _react.default.Component;
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(_class, _Component);

    function _class(props) {
      var _this;

      _this = _Component.call(this, props) || this;
      var datum = props.datum,
          onChange = props.onChange,
          initValidate = props.initValidate;
      var value = props[key];

      if (datum instanceof Datum) {
        _this.datum = datum;
      } else {
        var ops = bindProps.reduce(function (o, k) {
          o[k] = props[k];
          return o;
        }, {
          value: value,
          limit: limit,
          initValidate: initValidate
        });
        _this.datum = new Datum(Object.assign(ops, datum));
      }

      if (onChange) {
        _this.datum.onChange = onChange;
      }

      return _this;
    }

    var _proto = _class.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.prevValues = this.props[key];
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      // update datum.onchange
      if (prevProps.onChange !== this.props.onChange) {
        this.datum.onChange = this.props.onChange;
      }

      var values = this.props[key];

      if (!(0, _shallowEqual.default)(values, this.prevValues)) {
        this.setValue(this.props.initValidate ? undefined : _types.IGNORE_VALIDATE);
        this.prevValues = values;
      }
    };

    _proto.setValue = function setValue(t) {
      var values = this.props[key];
      if (ignoreUndefined && values === undefined) return;
      this.datum.setValue(values, t);
    };

    _proto.render = function render() {
      var _this$props = this.props,
          onDatumBind = _this$props.onDatumBind,
          props = _objectWithoutPropertiesLoose(_this$props, ["onDatumBind"]);

      if (onDatumBind) onDatumBind(this.datum);

      if (bindProps.includes('disabled') && props.disabled !== undefined) {
        this.datum.setDisabled(props.disabled);
      }

      if (type === 'list') this.setValue(_types.WITH_OUT_DISPATCH); // delete props[key]

      return _react.default.createElement(Origin, _extends({}, props, {
        datum: this.datum
      }));
    };

    return _class;
  }(Component), _defineProperty(_class, "propTypes", {
    onChange: _propTypes.default.func,
    onDatumBind: _propTypes.default.func,
    datum: _propTypes.default.object,
    initValidate: _propTypes.default.bool,
    value: _propTypes.default.any
  }), _defineProperty(_class, "defaultProps", {
    initValidate: false
  }), _temp;
});

exports.default = _default;